import React, {useCallback} from 'react';
import {SysPath} from 'SysContext';
import {RAjax} from '@putil-view/request.r-ajax';
import {RSpinner} from '@putil-view/item.components';
import PropTypes from 'prop-types';
export const UploadUnclearData = ({setState, uuid})=>{

	const handleUploadResult = useCallback((output) =>{
		if(output){
			setState(prevState =>{ return{...prevState , ...{result:output['text'], stage:"DISPLAY_RESULT"}}});
		}
	},[setState])

	const addUnclearRecordUrl = SysPath.addUnclearRecordUrl;
	return (
		<>
			<RAjax requestOptions={{
						method: 'post',
						withCredentials: true,
						url: addUnclearRecordUrl,
						data: {uuid:uuid.current}
					}}
					handleResponse={handleUploadResult}
			/>
	
			<span className="text-center" style={{width:'700px', height:'700px'}}> <RSpinner/></span>
			<h5 className="text-center">Uploading Unclear record</h5>
		</>
	)
}

UploadUnclearData.propTypes = {
	setState: PropTypes.func,
	uuid: PropTypes.oneOfType([
		PropTypes.func, 
		PropTypes.shape({ current: PropTypes.string })
	])
};

